import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from "../util/tss-react/index.js";
const useStyles = makeStyles()(theme => ({
    bg: {
        padding: 4,
        margin: 4,
        overflow: 'auto',
        maxHeight: 200,
        background: theme.palette.mode === 'dark' ? '#833' : '#f88',
        border: `1px solid ${theme.palette.divider}`,
    },
}));
export default function RedErrorMessageBox({ children, }) {
    const { classes } = useStyles();
    return _jsx("div", { className: classes.bg, children: children });
}
